import type { AvailabilityRow } from "@/content/availability";
import "./AvailabilityMatrix.css";

/**
 * Renders as a real `<table>` on wide viewports and as a stack of labelled
 * cards below `--availability-matrix-breakpoint` (see the CSS) — a wide
 * table squeezed onto a phone is not accessible, so this is two renderings
 * of the same data, not one table with overflow scroll.
 */
export function AvailabilityMatrix({ rows }: { rows: AvailabilityRow[] }) {
  return (
    <div className="availability-matrix">
      <table className="availability-matrix-table">
        <caption className="visually-hidden">Devory product availability matrix</caption>
        <thead>
          <tr>
            <th scope="col">Product</th>
            <th scope="col">Current stage</th>
            <th scope="col">Available to</th>
            <th scope="col">What works now</th>
            <th scope="col">What remains</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr key={row.product}>
              <th scope="row">{row.product}</th>
              <td>{row.stage}</td>
              <td>{row.availableTo}</td>
              <td>{row.worksNow}</td>
              <td>{row.remains}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <ul className="availability-matrix-cards">
        {rows.map((row) => (
          <li key={row.product} className="availability-matrix-card">
            <h3>{row.product}</h3>
            <dl>
              <div>
                <dt>Current stage</dt>
                <dd>{row.stage}</dd>
              </div>
              <div>
                <dt>Available to</dt>
                <dd>{row.availableTo}</dd>
              </div>
              <div>
                <dt>What works now</dt>
                <dd>{row.worksNow}</dd>
              </div>
              <div>
                <dt>What remains</dt>
                <dd>{row.remains}</dd>
              </div>
            </dl>
          </li>
        ))}
      </ul>
    </div>
  );
}
